import {createSlice} from '@reduxjs/toolkit';
import {jwtDecode} from 'jwt-decode';

const initialState = {
    isAuthenticated: false,
    user: null,
    token: null,
    role: null,
    exp: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState, // Use the initial state defined above
    reducers: {
        setAuthenticatedUser(state, action) {
            const  access_token  = action.payload;
            const decodedToken = jwtDecode(access_token);
            state.isAuthenticated = true;
            state.token = access_token;
            state.user = decodedToken.user;
            state.role = decodedToken.role;
            state.exp = decodedToken.exp;
        },
        logout(state) {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.role = null;
            state.exp = null;
        },
    },
});

export const { setAuthenticatedUser, logout } = authSlice.actions;
export default authSlice.reducer;
